import { object, string } from "yup";
import { isValidPhoneNumber } from "@shared-kernel/core/utils/phone-validation";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";
import { validatePassword } from "../../../write/domain/services/password";
import type { ActivateAccountBody } from "@shared-kernel/application/ports/public/public-repository";

export type AccountActivationFormInputs = {
  name: string;
  lastName: string;
  mobile: string;
  password: string;
};

export const defaultValues: AccountActivationFormInputs = {
  name: "",
  lastName: "",
  mobile: "",
  password: "",
};

export const schema = object().shape({
  name: string().max(255).required(REQUIRED_FIELD),
  lastName: string().max(255).required(REQUIRED_FIELD),
  mobile: string()
    .required("Veuillez saisir un numéro de téléphone")
    .test("mobile", "Numéro de téléphone invalide", async value => Boolean(value) && (await isValidPhoneNumber(value as string))),
  password: string()
    .required(REQUIRED_FIELD)
    .test("Mot de passe valide", "Le mot de passe n'est pas valide", password => validatePassword(password ?? "")),
});

export const accountActivationFormatFormDataToBodyData = (
  form: AccountActivationFormInputs,
  userId: string,
  token: string,
): ActivateAccountBody => {
  return {
    userId,
    token,
    name: form.name,
    lastName: form.lastName,
    mobile: form.mobile,
    password: form.password,
    profilePictureUrl: null,
  };
};
